// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3070 ? "8012d7e2" : chunkId) + "." + {"3070":"ab542f76087c5ea9","8889":"06b4f3eb4489c61c"}[chunkId] + ".js";
};